export default function guest ({ next, store, nextMiddleware }) {
  if (store.getters.logged) {
    return next({ name: 'home' });
  }
  return nextMiddleware();
};
